import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

//styles
import { FormGroup } from 'components/styled/Form.styled';

import ErrorField from '../ErrorField';
//components
import FormLabel from '../Label';

import Dropdown from './Dropdown';

const DropdownField = ({
  name,
  label,
  error,
  options,
  defaultValue,
  setFieldValue,
  isRequired,
  disabled,
  width,
  value,
  mb,
  onChange = undefined,
  isLoading = false,
}) => {
  return (
    <FormGroup width={width} mb={mb}>
      {label && (
        <FormLabel
          isRequired={isRequired}
          label={label}
          name={name}
          error={error}
          disabled={disabled}
        />
      )}
      <Dropdown
        setFieldValue={setFieldValue}
        defaultValue={defaultValue}
        options={options}
        name={name}
        error={error}
        disabled={disabled}
        value={value}
        onChange={onChange}
        isLoading={isLoading}
      />
      <ErrorMessage name={name} component={ErrorField} />
    </FormGroup>
  );
};

DropdownField.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  defaultValue: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    }),
  ),
  error: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  width: PropTypes.string,
  value: PropTypes.object,
  mb: PropTypes.string,
};

export default DropdownField;
